export const initValidation = ($containers) => {
	$containers.each(function(index, container) {
		const $container = $(container);
		const $form = $('form', $container);
		const $modalSuccess = $($container.data('modal-success'));
		const $modalError = $($container.data('modal-error'));
		const $select = $('select', $container);

		$form.validate({
			errorElement: 'span',
			errorClass: 'error',
			validClass: 'success',

			highlight: function (element, errorClass, validClass) {
				$(element).parent().addClass(errorClass);
				$form.addClass(errorClass);
			},

			unhighlight: function (element, errorClass, validClass) {
				$(element).parent().removeClass(errorClass);
				$form.removeClass(errorClass);
			},

			submitHandler: function(form,event) {
				event.preventDefault();
				$(form).trigger('GalaxyEventForm');
				$.post(window._dynamic_base + '/lead/' + window.websiteID, $form.serialize())
					.then(function (data) {
						$container.addClass('success')
					}).fail(function () {
						$container.addClass('error');
					})
			}
		});

		$select.on('change', function() {
			$(this).valid();
		});
	});
}

export default function formsUI() {
	initValidation($('.js-form'));
}
